import PatientPayResendLinkButton from "@/components/patientPay/PatientPayResendLinkButton";
import PatientPayStatusPage from "@/components/patientPay/PatientPayStatusPage";

export default function PatientPayExpiredLinkPage({ orderId }) {
  return (
    <PatientPayStatusPage
      title="Order link expired"
      action={<PatientPayResendLinkButton orderId={orderId} />}
    >
      Payment links expire after a short time to keep your order secure. Your order is still safe.
      Request a new link and we&apos;ll email it to the address your practitioner used when they set
      up your order.
    </PatientPayStatusPage>
  );
}
